export default {
    baseStyle: {
        confirmContainer: {
            maxWidth: 'container.md',
            py: {base: 7, md: 16},
            px: {base: '20px', md: 4}
        },
        confirmStack: {
            spacing: 4
        },
        confirmBoxPadd: {
            py: [6, 6, 8],
            borderTop: '1px solid',
            borderColor: 'gray.100'
        },
        confirmStackSpc: {
            spacing: 3
        },
        confirmHeading: {
            align: 'center',
            fontSize: {base: '22px', md: '36px'},
            fontFamily: 'UniversLTStd, Arial, sans-serif',
            textTransform: 'uppercase',
            marginBottom: '12px'
        },
        confirmStackSpcSm: {
            spacing: 3
        },
        confirmTextGlobal: {
            align: 'center',
            fontSize: {base: '14px', md: '16px'}
        },
        borderUp: {
            borderTop: '1px solid',
            borderColor: 'gray.100',
            paddingTop: '10px',
            marginTop: '10px'
        },
        buttonConfirm: {
            margin: '3rem auto 0',
            width: 'fit-content',
            display: 'flex',
            justifyContent: 'center',
            textDecoration: 'none!important'
        },
        confirmRedirectLink: {
            textDecoration: 'underline'
        },
        laClubLaurasterMain: {
            display: 'flex',
            flexDirection: {base: 'column', md: 'row'},
            gap: {base: '12px', md: '30px'},
            maxWidth: {base: 'unset', md: '575px'},
            width: '100%',
            margin: '0 auto',
            '& p:first-of-type': {
                ['img']: {
                    width: {base: '150px', md: '370px'},
                    margin: 'auto'
                }
            },
            '& p:last-of-type': {
                textAlign: {base: 'center', md: 'left'},
                fontSize: {base: '14px', md: '16px'},
                a: {
                    textDecoration: 'underline'
                }
            },
            ['img']: {
                width: {base: '150px', md: '370px'},
                margin: 'auto'
            }
        },
        laClubLaurasterMainButton: {
            margin: '1.5rem auto 3rem',
            width: 'auto',
            display: 'flex',
            justifyContent: 'center',
            background: 'blackAlpha.250'
        },
        hasJustJoinedClub: {
            align: 'center',
            fontSize: {base: '14px', md: '16px'},
            color: 'blue.500',
            marginBottom: '3rem'
        }
    }
}
